<ion-content>
  <ion-list class="ion-no-padding">
    <ion-item button (click)="close('profile')">
      <ion-icon slot="start" name="person-outline"></ion-icon>
      <ion-label>Perfil de usuario</ion-label>
    </ion-item>
    <ion-item button (click)="close('logout')" lines="none">
      <ion-icon slot="start" name="log-out-outline"></ion-icon>
      <ion-label>Cerrar sesión</ion-label>
    </ion-item>
  </ion-list>
</ion-content>
